module.exports = __webpack_public_path__ + "static/img/3.91be9a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/3.png
// module id = ZNlh
// module chunks = 0